"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CurrencyGeneralHandler", {
    enumerable: true,
    get: function() {
        return CurrencyGeneralHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _decimalgeneralhandler = require("../decimal/decimal.general.handler");
const _ncError = require("~/helpers/ncError");
let CurrencyGeneralHandler = class CurrencyGeneralHandler extends _decimalgeneralhandler.DecimalGeneralHandler {
    async parseUserInput(params) {
        if (typeof params.value === 'string') {
            const locale = (0, _nocodbsdk.parseProp)(params.column.meta).currency_locale;
            const numericValueResult = (0, _nocodbsdk.getNumericValue)(params.value, locale);
            if (!numericValueResult.isValid) {
                _ncError.NcError._.invalidValueForField({
                    value: params.value,
                    column: params.column.title,
                    type: params.column.uidt
                });
            }
            return {
                value: numericValueResult.numericValue
            };
        }
        return super.parseUserInput(params);
    }
};
